import axios from "axios"
import store from '@/store/index.js'
import { Toast } from 'vant';
import { encrypt, decrypt } from '@/utils/aes.js'
//通过axios.defaults.timeout设置默认的请求超时时间。例如超过了5s，就会告知用户当前请求超时，请刷新等。
//axios.defaults.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
//请求拦截器
let ajaxTimes = 0;
let urlList = [
  "/api/biz/Hospitalization/getIpPatient",
  "/api/biz/QueryPrinting/getCkLabResult"
]
// axios.defaults.timeout = 5000;
axios.interceptors.request.use(config => {
  if(urlList.includes(config.url)){
    config.data = { data: encrypt(JSON.stringify(config.data)) }
  }
  if(ajaxTimes == 0){
    store.commit('showLoading');
  }
  ajaxTimes++;
  store.commit("hideRefresh");
  return config
}, error => {
  ajaxTimes--;
  if(ajaxTimes <= 0 && store.state.LOADING){
    store.commit('hideLoading');
  }
  return Promise.reject(error);
})
//响应拦截器
axios.interceptors.response.use(
  response => {
    if(urlList.includes(response.config.url)){
      response.data.obj.resultData = JSON.parse(JSON.parse(decrypt(response.data.obj.resultData)))
    }
    ajaxTimes--;
    if(ajaxTimes <= 0 && store.state.LOADING){
      store.commit('hideLoading');
    }
    // if(response == undefined){
    //   store.commit('hideLoading');
    // }
    // if (response.status == 200) {
    //   // ajaxTimes--
    //   // if (ajaxTimes == 0) {
    //     store.commit('hideLoading');
    //   // }
    //   return Promise.resolve(response);
    // } else {
    //   store.commit('hideLoading')
    //   return Promise.reject(response);
    // }
    return Promise.resolve(response);
  },
  error => {
    ajaxTimes--;
    if(ajaxTimes <= 0 && store.state.LOADING){
      store.commit('hideLoading');
    }
    return Promise.reject(error);
  }
)
/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(response => {
        resolve(response);
        if(response.data.state == 500 && response.data.obj == null){
          store.commit("showRefresh")
        }
      })
      .catch(err => {
        store.commit("showRefresh");
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response);
        if(response.data.state == 500 && response.data.obj == null){
          store.commit("showRefresh")
        }
      }, err => {
        Toast.fail("Request failed with status code 500");
        store.commit("showRefresh")
        reject(err)
      })
  })
}

/**
* 封装patch请求
* @param url
* @param data
* @returns {Promise}
*/

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
* 封装put请求
* @param url
* @param data
* @returns {Promise}
*/

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}


// WEBPACK FOOTER //
// ./src/request/http.js